import { createContext } from "react";
import { ClientsMetadataManager } from "@shared/types";

export const ClientsDataContext = createContext<
  ClientsMetadataManager | undefined
>(undefined);
